var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row gutter-sm" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-2" },
        [
          _c(
            "div",
            { staticClass: "content", on: { click: _vm.handleFileChange } },
            [
              _c("div", { staticClass: "content-overlay" }),
              _vm.user_image == null
                ? _c("img", {
                    key: _vm.cod,
                    staticClass: "content-image",
                    attrs: { src: _vm.getPlaceholder }
                  })
                : _vm._e(),
              _vm.user_image
                ? _c("img", {
                    key: _vm.cod,
                    staticClass: "content-image",
                    attrs: { src: _vm.user_image },
                    on: { error: _vm.errorImage }
                  })
                : _vm._e(),
              _c("div", { staticClass: "content-details fadeIn-top" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("change_image")))])
              ])
            ]
          ),
          _c("input", {
            directives: [{ name: "uploader", rawName: "v-uploader" }],
            ref: "file",
            staticStyle: { display: "none" },
            attrs: { type: "file", accept: ".gif,.jpg,.jpeg,.png" }
          }),
          _c("uploader", {
            staticStyle: { display: "none" },
            attrs: {
              file: _vm.file,
              aspect_ratio: 1 / 1,
              aspect_ratio_string: "1/1"
            },
            on: {
              fileUploaded: _vm.fileUploaded,
              uploadStarted: _vm.uploadStarted
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
        _c("div", { staticClass: "row gutter-md q-mb-md" }, [
          _c(
            "div",
            {
              staticClass: "col-12 text-h6",
              class: _vm.$q.platform.is.mobile ? "text-white" : ""
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("personal_information")) +
                  "\n                "
              )
            ]
          ),
          _vm.user_profile.full_name
            ? _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("name"),
                      error: _vm.$v.full_name.$error,
                      disable: _vm.user_profile.full_name_disabled
                    },
                    on: { input: _vm.$v.full_name.$touch },
                    model: {
                      value: _vm.full_name,
                      callback: function($$v) {
                        _vm.full_name = $$v
                      },
                      expression: "full_name"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.user_profile.nickname
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("nick_name"),
                      error: _vm.$v.nickname.$error,
                      disable: _vm.user_profile.nickname_disabled
                    },
                    on: { input: _vm.$v.nickname.$touch },
                    model: {
                      value: _vm.nickname,
                      callback: function($$v) {
                        _vm.nickname = $$v
                      },
                      expression: "nickname"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.user_profile.email
            ? _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.$v.email.$error,
                        "error-label": _vm.$t(_vm.email_error_message)
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("email"),
                          type: "email",
                          error: _vm.$v.email.$error,
                          disable: _vm.user_profile.email_disabled
                        },
                        on: {
                          input: _vm.$v.email.$touch,
                          blur: function($event) {
                            return _vm.emailUnique()
                          }
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.user_profile.document
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.document_error,
                        "error-label": _vm.document_error
                          ? _vm.$t("document_not_unique")
                          : ""
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": "" + _vm.$t(_vm.documentIsCPF),
                          error: _vm.$v.document.$error,
                          disable: _vm.user_profile.document_disabled
                        },
                        on: {
                          input: _vm.$v.document.$touch,
                          blur: function($event) {
                            return _vm.documentUnique()
                          }
                        },
                        model: {
                          value: _vm.document,
                          callback: function($$v) {
                            _vm.document = $$v
                          },
                          expression: "document"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.user_profile.birthday
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("q-datetime", {
                    attrs: {
                      "float-label": _vm.$t("birthday"),
                      format: "DD/MM",
                      type: "date",
                      error: _vm.$v.birthday.$error,
                      disable: _vm.user_profile.birthday_disabled,
                      "format-model": "date"
                    },
                    on: { input: _vm.$v.birthday.$touch },
                    model: {
                      value: _vm.birthday,
                      callback: function($$v) {
                        _vm.birthday = $$v
                      },
                      expression: "birthday"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.user_profile.gender
            ? _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.getUserGenders,
                      "float-label": _vm.$t("gender"),
                      error: _vm.$v.gender.$error,
                      disable: _vm.user_profile.gender_disabled
                    },
                    on: { input: _vm.$v.gender.$touch },
                    model: {
                      value: _vm.gender,
                      callback: function($$v) {
                        _vm.gender = $$v
                      },
                      expression: "gender"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm.user_profile.marital_status
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-select", {
                attrs: {
                  options: _vm.marital_statuses,
                  "float-label": _vm.$t("marital"),
                  clearable: "",
                  error: _vm.$v.marital_status.$error,
                  disable: _vm.user_profile.marital_status_disabled
                },
                on: { input: _vm.$v.marital_status.$touch },
                model: {
                  value: _vm.marital_status,
                  callback: function($$v) {
                    _vm.marital_status = $$v
                  },
                  expression: "marital_status"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user_profile.number_of_children
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-input", {
                attrs: {
                  type: "number",
                  "float-label": _vm.$t("number_of_children"),
                  error: _vm.$v.number_of_children.$error,
                  disable: _vm.user_profile.number_of_children_disabled
                },
                on: { input: _vm.$v.number_of_children.$touch },
                model: {
                  value: _vm.number_of_children,
                  callback: function($$v) {
                    _vm.number_of_children = $$v
                  },
                  expression: "number_of_children"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user_profile.register
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.register_error,
                    "error-label": _vm.register_error
                      ? _vm.$t("register_not_unique")
                      : ""
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("register"),
                      error: _vm.$v.register.$error,
                      disable:
                        _vm.user_profile.register_disabled || _vm.isChevrolet
                    },
                    on: {
                      input: _vm.$v.register.$touch,
                      blur: function($event) {
                        return _vm.registerUnique()
                      }
                    },
                    model: {
                      value: _vm.register,
                      callback: function($$v) {
                        _vm.register = $$v
                      },
                      expression: "register"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isChevrolet && _vm.user_profile.register_2
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.register_2_error,
                    "error-label": _vm.register_2_error
                      ? _vm.$t("gmin_number_not_unique")
                      : ""
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("gmin_number"),
                      error: _vm.$v.register_2.$error,
                      disable: _vm.user_profile.register_2_disabled
                    },
                    on: {
                      input: _vm.$v.register_2.$touch,
                      blur: function($event) {
                        return _vm.register2Unique()
                      }
                    },
                    model: {
                      value: _vm.register_2,
                      callback: function($$v) {
                        _vm.register_2 = $$v
                      },
                      expression: "register_2"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.user_profile.is_handicapped
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-select", {
                attrs: {
                  options: [
                    { value: true, label: _vm.$t("yes") },
                    { value: false, label: _vm.$t("no") }
                  ],
                  "float-label": _vm.$t("is_handicapped"),
                  disable: _vm.user_profile.is_handicapped_disabled
                },
                model: {
                  value: _vm.is_handicapped,
                  callback: function($$v) {
                    _vm.is_handicapped = $$v
                  },
                  expression: "is_handicapped"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user_profile.handicap_description
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("handicap_description"),
                  error: _vm.$v.handicap_description.$error,
                  disable:
                    _vm.user_profile.handicap_description_disabled ||
                    !_vm.is_handicapped
                },
                on: { input: _vm.$v.handicap_description.$touch },
                model: {
                  value: _vm.handicap_description,
                  callback: function($$v) {
                    _vm.handicap_description = $$v
                  },
                  expression: "handicap_description"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "row gutter-sm col-12 q-mb-md" }, [
        _c(
          "div",
          {
            staticClass: "col-12 text-h6",
            class: _vm.$q.platform.is.mobile ? "text-white" : ""
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("contact_information")) +
                "\n        "
            )
          ]
        ),
        _vm.user_profile.mobile_phone
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-lg-3" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("mobile"),
                    error: _vm.$v.phone_mobile.phone.$error,
                    disable: _vm.user_profile.mobile_phone_disabled
                  },
                  on: { input: _vm.$v.phone_mobile.phone.$touch },
                  model: {
                    value: _vm.phone_mobile.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "phone", $$v)
                    },
                    expression: "phone_mobile.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.user_profile.whatsapp_phone
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-lg-3" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("whatsapp"),
                    error: _vm.$v.phone_whatsapp.phone.$error,
                    disable: _vm.user_profile.whatsapp_phone_disabled
                  },
                  on: { input: _vm.$v.phone_whatsapp.phone.$touch },
                  model: {
                    value: _vm.phone_whatsapp.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_whatsapp, "phone", $$v)
                    },
                    expression: "phone_whatsapp.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.user_profile.commercial_phone
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-lg-3" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("commercial"),
                    error: _vm.$v.phone_commercial.phone.$error,
                    disable: _vm.user_profile.commercial_phone_disabled
                  },
                  on: { input: _vm.$v.phone_commercial.phone.$touch },
                  model: {
                    value: _vm.phone_commercial.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_commercial, "phone", $$v)
                    },
                    expression: "phone_commercial.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.user_profile.home_phone
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-lg-3" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("residential"),
                    error: _vm.$v.phone_residential.phone.$error,
                    disable: _vm.user_profile.home_phone_disabled
                  },
                  on: { input: _vm.$v.phone_residential.phone.$touch },
                  model: {
                    value: _vm.phone_residential.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_residential, "phone", $$v)
                    },
                    expression: "phone_residential.phone"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.user_profile.address
        ? _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
            _c("div", [
              _vm.$q.platform.is.mobile
                ? _c("div", { staticClass: "col-12 text-h6 text-white" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("address")) +
                        "\n            "
                    )
                  ])
                : _c("div", { staticClass: "col-12 text-h6" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("address")) +
                        "\n            "
                    )
                  ])
            ]),
            _vm.keyGooogleMaps && _vm.user_profile.address
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          error: _vm.show_maps_alert,
                          "error-label": _vm.$t(
                            "not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code"
                          )
                        }
                      },
                      [
                        _c(
                          "q-input",
                          {
                            attrs: {
                              "float-label": _vm.$t("address"),
                              autocomplete: "new-password",
                              error: _vm.$v.address.$error,
                              disable: _vm.user_profile.address_disabled,
                              placeholder: _vm.$t(
                                "search_by_name_and_street_number"
                              )
                            },
                            on: { input: _vm.$v.address.$touch },
                            model: {
                              value: _vm.address,
                              callback: function($$v) {
                                _vm.address = $$v
                              },
                              expression: "address"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: { "min-characters": 3, separator: "" },
                              on: {
                                search: _vm.getAddressGoogleMaps,
                                selected: _vm.selectedAddressGoogleMaps
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-input",
                      {
                        attrs: {
                          "float-label": _vm.$t("address"),
                          autocomplete: "new-password",
                          error: _vm.$v.address.$error,
                          disable: _vm.user_profile.address_disabled
                        },
                        on: { input: _vm.$v.address.$touch },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3, separator: "" },
                          on: {
                            search: _vm.getAddress,
                            selected: _vm.selectedAddress
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  ref: "number",
                  attrs: {
                    "float-label": _vm.$t("number"),
                    disable: _vm.user_profile.address_disabled
                  },
                  model: {
                    value: _vm.number,
                    callback: function($$v) {
                      _vm.number = $$v
                    },
                    expression: "number"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("neighborhood"),
                    disable: _vm.user_profile.address_disabled
                  },
                  model: {
                    value: _vm.neighborhood,
                    callback: function($$v) {
                      _vm.neighborhood = $$v
                    },
                    expression: "neighborhood"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("complement"),
                    disable: _vm.user_profile.address_disabled
                  },
                  model: {
                    value: _vm.complement,
                    callback: function($$v) {
                      _vm.complement = $$v
                    },
                    expression: "complement"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("postal_code"),
                    disable: _vm.user_profile.address_disabled
                  },
                  model: {
                    value: _vm.postal_code,
                    callback: function($$v) {
                      _vm.postal_code = $$v
                    },
                    expression: "postal_code"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("country"),
                    error: _vm.$v.country.$error,
                    disable: _vm.user_profile.address_disabled
                  },
                  on: { input: _vm.$v.country.$touch },
                  model: {
                    value: _vm.country,
                    callback: function($$v) {
                      _vm.country = $$v
                    },
                    expression: "country"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("city"),
                    error: _vm.$v.city.$error,
                    disable: _vm.user_profile.address_disabled
                  },
                  on: { input: _vm.$v.city.$touch },
                  model: {
                    value: _vm.city,
                    callback: function($$v) {
                      _vm.city = $$v
                    },
                    expression: "city"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("state"),
                    disable: _vm.user_profile.address_disabled
                  },
                  model: {
                    value: _vm.state,
                    callback: function($$v) {
                      _vm.state = $$v
                    },
                    expression: "state"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.user_profile.user_type
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("q-select", {
                attrs: {
                  options: _vm.getUserTypes,
                  "float-label": _vm.$t("user_type"),
                  error: _vm.$v.user_type.$error,
                  disable: _vm.user_profile.user_type_disabled
                },
                on: { input: _vm.$v.user_type.$touch },
                model: {
                  value: _vm.user_type,
                  callback: function($$v) {
                    _vm.user_type = $$v
                  },
                  expression: "user_type"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row gutter-sm justify-end q-mt-sm q-mb-md" },
          [
            !_vm.getIsDisabled
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-3" },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("save"),
                        icon: "far fa-save"
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveData()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: _vm.$t("galery"),
                      icon: "far fa-images"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setSource("galery")
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("camera"),
                      icon: "fas fa-camera"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setSource("camera")
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.select_source,
            callback: function($$v) {
              _vm.select_source = $$v
            },
            expression: "select_source"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("select_source")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("select_the_image_source")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }